function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 353.427,
  y: 319.639,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -125.4831 358.5964)",
  width: 33.391,
  height: 22.261
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 314.07,
  y: 358.994,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -164.8388 342.2935)",
  width: 33.391,
  height: 22.261
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 400.656,
  y: 366.851,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -145.034 405.8207)",
  width: 33.391,
  height: 22.261
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 361.299,
  y: 406.213,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -184.3942 389.5197)",
  width: 33.391,
  height: 22.261
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 377.04,
  y: 343.247,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -135.2602 382.2079)",
  width: 33.391,
  height: 22.261
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 337.694,
  y: 382.602,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -174.6126 365.9128)",
  width: 33.391,
  height: 22.261
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 329.544,
  y: 126.805,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 541.0344 499.9738)",
  width: 89.043,
  height: 22.261
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 314.081,
  y: 130.749,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 464.3475 476.0975)",
  width: 33.391,
  height: 22.26
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 353.427,
  y: 170.098,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 503.692 571.0911)",
  width: 33.391,
  height: 22.26
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 361.282,
  y: 83.526,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 578.3161 428.8593)",
  width: 33.391,
  height: 22.261
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 400.651,
  y: 122.879,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 617.6954 523.8765)",
  width: 33.391,
  height: 22.261
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 69.81,
  y: 386.542,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 314.6838 35.6313)",
  width: 89.043,
  height: 22.261
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 140.919,
  y: 382.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 324.573 3.8704)",
  width: 33.391,
  height: 22.26
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 101.569,
  y: 343.252,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 285.2246 20.1705)",
  width: 33.391,
  height: 22.261
});

var _ref16 =
/*#__PURE__*/
React.createElement("rect", {
  x: 117.031,
  y: 339.316,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 295.1205 -11.5916)",
  width: 89.043,
  height: 22.261
});

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  x: 69.81,
  y: 103.201,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 276.0196 114.331)",
  width: 89.043,
  height: 22.261
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 93.412,
  y: 126.806,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 333.0029 137.9383)",
  width: 89.043,
  height: 22.261
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 117.038,
  y: 150.428,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 390.0373 161.557)",
  width: 89.043,
  height: 22.26
});

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var _ref24 =
/*#__PURE__*/
React.createElement("g", null);

var _ref25 =
/*#__PURE__*/
React.createElement("g", null);

var _ref26 =
/*#__PURE__*/
React.createElement("g", null);

var _ref27 =
/*#__PURE__*/
React.createElement("g", null);

var _ref28 =
/*#__PURE__*/
React.createElement("g", null);

var _ref29 =
/*#__PURE__*/
React.createElement("g", null);

var _ref30 =
/*#__PURE__*/
React.createElement("g", null);

var _ref31 =
/*#__PURE__*/
React.createElement("g", null);

var _ref32 =
/*#__PURE__*/
React.createElement("g", null);

var _ref33 =
/*#__PURE__*/
React.createElement("g", null);

var _ref34 =
/*#__PURE__*/
React.createElement("g", null);

var SvgKrw = function SvgKrw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M345.043,256c0,22.261-39.866,77.913-89.043,77.913S166.957,278.261,166.957,256 c0-49.178,39.866-89.043,89.043-89.043S345.043,206.822,345.043,256z"
  }), React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M345.043,256c0,49.178-39.866,89.043-89.043,89.043S166.957,305.178,166.957,256"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKrw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/KRW.8a067f19.svg";
export { ForwardRef as ReactComponent };